import ConnectedRightSection from "./RightSection";

export default ConnectedRightSection;
